import http from "../helpers/httpCommon";

class WidgetService {
    create(data) {
        return http().post("/widgetCreate", data);
    }

    read(data) {
        return http().post("/widgetRead", data);
    }

    update(data) {
        return http().post(`/widgetUpdate`, data);
    }

    delete(data) {
        return http().post(`/widgetDelete`, data);
    }

    list(data) {
        return http().post("/widgetList", data)
    }
}

export default new WidgetService();
